import React from 'react';
import { Link } from 'react-router-dom';

export default function DashboardSummaryCards({ cards, cardSurface, cardBorder, cardMuted }) {
  return (
    <div className="w-full max-w-[960px] mt-8 mb-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Link
          key={card.title}
          to={card.href}
          aria-label={card.ariaLabel}
          className="dashboard-summary-card rounded-2xl p-5 transition-all"
          style={{
            backgroundColor: cardSurface,
            border: `1px solid ${cardBorder}`,
          }}
        >
          <div className="text-[11px] font-extrabold uppercase tracking-[0.18em] mb-3" style={{ color: cardMuted }}>
            {card.title}
          </div>
          <div className="text-2xl font-headline font-extrabold mb-2" style={{ color: card.accent }}>
            {card.value}
          </div>
          <div className="text-sm leading-relaxed" style={{ color: cardMuted }}>
            {card.detail}
          </div>
        </Link>
      ))}
    </div>
  );
}
